<div class="category-header" (click)="expanded = !expanded">
  <h4 class="ml-2">{{ title }}</h4>
  <button
    *ngIf="expanded; else collapsed"
    nf-icon-button="secondary"
    icon="chevron-down"
    class="btn-bare"
    ngbTooltip="Collapse Category"
  >
    Collapse {{ title }} Category
  </button>
  <ng-template #collapsed>
    <button
      nf-icon-button="secondary"
      icon="chevron-right"
      class="btn-bare"
      ngbTooltip="Expand Category"
    >
      Expand {{ title }} Category
    </button>
  </ng-template>
</div>
<div class="category-content" *ngIf="expanded && workspaces != null">
  <hs-workspace-card
    *ngFor="let workspace of workspaces"
    [workspace]="workspace"
    [isPreset]="isPreset"
    [isDefault]="workspace.workspacePrefix === defaultWorkspacePrefix"
    (cloneWorkspace)="cloneWorkspace.emit($event)"
  >
  </hs-workspace-card>
</div>
